import { render, staticRenderFns } from "./ContactThankYou.vue?vue&type=template&id=48ebeb3a&scoped=true"
import script from "./ContactThankYou.vue?vue&type=script&lang=js"
export * from "./ContactThankYou.vue?vue&type=script&lang=js"
import style0 from "./ContactThankYou.vue?vue&type=style&index=0&id=48ebeb3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ebeb3a",
  null
  
)

export default component.exports